import type { UndecoratedUser } from '@witmetrics/utils';
import { theme } from '@/utils/theme';

export const classes = {
  avatar: 'cursor-pointer',
};
export const styles = {
  shared: (size: number) => ({
    height: size,
    width: size,
  }),
  avatar: {
    bgcolor: theme.palette['grey-5'].main,
    color: theme.palette['grey-2'].main,
  },
  circularProgress: {
    color: theme.palette['orange-3'].main,
    animationDuration: '2s',
    '& .MuiCircularProgress-circle': {
      animationDuration: '2s',
    },
  },
};

export function getUserLabels({
  firstname,
  lastname,
}: Pick<UndecoratedUser, 'firstname' | 'lastname'>) {
  return {
    name: `${firstname} ${lastname}`,
    initials: `${firstname.slice(0, 1)}${lastname.slice(0, 1)}`.toUpperCase(),
  };
}
